// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { GetAccountApiParameter } from "@insite/client-framework/Services/AccountService";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { chain, DispatchSetInitialValues } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/DisplayUser";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<{ userId: string }, GetAccountApiParameter, AccountModel>;

export const XDispatchSetInitialValues: HandlerType = props => {
    let user = getAccountState(props.getState(), props.parameter.userId).value;

    if (!user!.properties.language) {
        user = {
            ...user,
            properties: {
                ...user!.properties,
                language: props.getState().context.session.language?.id,
            },
        } as any;
    }

    props.dispatch({
        type: "xAccountSettings/updateAccountSettings",
        ...user,
    } as any);

    props.dispatch({
        type: "xUserSetup/updateUserSetup",
        ...user,
    } as any);
};

addToChainAfter(chain, DispatchSetInitialValues, XDispatchSetInitialValues);
